import React from 'react';
import { cn } from '@/lib/utils';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const DatePicker = React.forwardRef(({ className, id, label, value, onChange, ...props }, ref) => {
  return (
    <div className={cn('grid gap-2', className)}>
      {label && <Label htmlFor={id} className="text-slate-300">{label}</Label>}
      <Input
        ref={ref}
        id={id}
        type="date"
        value={value ? new Date(value).toISOString().split('T')[0] : ''}
        onChange={(e) => onChange(e.target.value ? new Date(e.target.value).toISOString() : null)}
        className="bg-slate-700 border-slate-600 text-slate-100 placeholder:text-slate-400 focus-visible:ring-blue-500"
        {...props}
      />
    </div>
  );
});
DatePicker.displayName = 'DatePicker';

export { DatePicker };